export enum EInfrastructure {
  CarWash = 'CarWash',
  CarService = 'CarService',
  Pharmacy = 'Pharmacy',
  ClothesStudio = 'ClothesStudio',
  ATM = 'ATM',
  Pool = 'Pool',
  Buffet = 'Buffet',
  WarehouseComplex = 'WarehouseComplex',
  Hotel = 'Hotel',
  Cafe = 'Cafe',
  Cinema = 'Cinema',
  ConferenceRoom = 'ConferenceRoom',
  MedicalCenter = 'MedicalCenter',
  Minimarket = 'Minimarket',
  NotaryOffice = 'NotaryOffice',
  BankDepartment = 'BankDepartment',
  Park = 'Park',
  Restaurant = 'Restaurant',
  BeautyShop = 'BeautyShop',
  Warehouse = 'Warehouse',
  Canteen = 'Canteen',
  Supermarket = 'Supermarket',
  ShoppingArea = 'ShoppingArea',
  FitnessCentre = 'FitnessCentre',
  Studio = 'Studio',
  CentralReception = 'CentralReception',
}
